import _ from 'lodash';

import Entity from './Entity';

import Fee from './Fee';


const accessDeviceEntityFieldsWithDynamicAllowedValues = {
  type: { enumName: "AccessDeviceTypeEnum" },
  status: { enumName: "AccessDeviceStatusEnum" },
  device_inactive_reason: { enumName: "accessDeviceInactiveReasonEnum" },
};

const accessDeviceEntityFieldsWithStaticAllowedValues = {
  required: {
    options: [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' }
    ]
  },
  offered: {
    options: [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' }
    ]
  }
};


export default class AccessDevice {
  fields = {
    id: {
      value: null
    },
    type: {
      value: null
    },
    required: {
      value: null
    },
    offered: {
      value: null
    },
    fee: {
      value: null
    }
  };

  data = {
    charge: {
      value: null
    }
  };


  static createFromQueryValues(values) {
    const accessDevice = new this();

    for (let field in accessDevice.fields) {
      if (values.hasOwnProperty(field)) {
        switch (field) {
          case 'fee':
            accessDevice.fields[field].value = (values[field] === null) ?
              values[field] :
              Fee.createFromQueryValues(values[field]);
            break;
          default:
            accessDevice.fields[field].value = values[field];
        }
      }
    }

    for (let datum in accessDevice.data) {
      switch (datum) {
        case 'charge':
          accessDevice.data[datum].value = (accessDevice.fields.fee.value !== null);
          break;
        default:
      }
    }

    return accessDevice;
  }


  static getFieldAllowedValues(fields) {
    return Entity.getFieldAllowedValues(
      accessDeviceEntityFieldsWithStaticAllowedValues,
      accessDeviceEntityFieldsWithDynamicAllowedValues,
      fields
    );
  }


  getQueryFieldValues() {
    if (this.fields.type.value === null) {
      return false;
    }

    const values = _.cloneDeep(AccessDeviceInput);

    for (let field in values) {
      switch (field) {
        case 'id':
          if (this.fields[field].value === null) {
            delete values.id;
          }
          else {
            values[field] = this.fields[field].value;
          }
          break;
        case 'fee':
          if (this.fields[field].value !== null) {
            values[field] = this.fields[field].value.getQueryFieldValues();
          }
          break;
        default:
          if (this.fields[field].value !== null) {
            values[field] = this.fields[field].value;
          }
      }
    }

    return values;
  }
}


export const AccessDeviceInput = {
  id: null,
  type: null,
  required: null,
  offered: null,
  fee: null
}
